import { render, staticRenderFns } from "./CinemaForm.vue?vue&type=template&id=579b56f4&scoped=true&"
import script from "./CinemaForm.vue?vue&type=script&lang=js&"
export * from "./CinemaForm.vue?vue&type=script&lang=js&"
import style0 from "./CinemaForm.vue?vue&type=style&index=0&id=579b56f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b56f4",
  null
  
)

export default component.exports